<div id="transfers" style="display:none;margin-top: 3rem;">
    <app-header title=""></app-header>
    <div class="px-5 pt-4">
        <div class="row custom-material-form updated-dropdown">
            <div class="col">
                <div class="md-form">
                    <input placeholder="Start date" type="text" id="transStartDatePicker" class="form-control datepicker" style="cursor: pointer;">
                    <label id="transStartDatePickerLabel" for="transStartDatePicker">Start Date</label>
                    <i class="far fa-calendar-alt calendar-icon--paybee" onclick="document.getElementById('transStartDatePicker').focus()" style="cursor:pointer"></i>
                </div>
            </div>
            <div class="col">
                <div class="md-form">
                    <input placeholder="End date" type="text" id="transEndDatePicker" class="form-control datepicker" style="cursor: pointer;">
                    <label id="transEndDatePickerLabel" for="transEndDatePicker">End Date</label>
                    <i class="far fa-calendar-alt calendar-icon--paybee" onclick="document.getElementById('transEndDatePicker').focus()" style="cursor:pointer"></i>
                </div>
            </div>
        </div>
        <div class="row text-center">
            <div class="col text-center">
                <div id="noTransactionData" style="display:none">
                    <p class="no-data-text">No transaction data available for selected dates</p>
                </div>
            </div>
        </div>
        <div id="transferPage" class="content col-sm-12 col-md-12 col-lg-12">
            <h5 style="margin-top: 20px">Summary Totals</h5>
            <div class="row text-center" style="background:#f8f8f8; padding:10px 0px 10px 0px">
                <div class="col transferSummary">
                    <span>Transfers</span><br>
                    <span id="totalPayouts"></span>
                </div>
                <div class="col transferSummary">
                    <span>Transfer amount</span><br>
                    <span id="totalPayoutAmount"></span>
                </div>
                <div class="col">
                    <span>Donation amount</span><br>
                    <span id="totalDonationAmount"></span>
                </div>
            </div>
            <div class="row text-center" style="background:#f8f8f8; padding:10px 0px 10px 0px">
                <div class="col transferSummary" >
                    <span>Total fee</span><br>
                    <span id="totalOrgFee"></span>
                </div>
                <div class="col transferSummary">
                    <span>Refunds</span><br>
                    <span id="totalRefunds">$0.00</span>
                </div>
                <div class="col transferSummary">
                    <span>Tax Collected</span><br>
                    <span id="totalTaxes">$0.00</span>
                </div>
                <div class="col">
                    <span>Adjustments</span><br>
                    <span id="totalAdjustments">$0.00</span>
                </div>
            </div>
    
            <h5 style="margin-top: 20px">Campaign Breakdown</h5>
            <div class="row">
                <div class="col text-center">
                    <canvas class="text-center" id="pieChart" style="max-width: 500px"></canvas>
                </div>
            </div>
            <div class="row">
                <div class="col text-center">
                    <button class="btn btn-info btn-sm" id="pieChartButton">Show transfer by campaigns</button>
                </div>
                <div class="col text-center">
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <h5 style="margin-top: 20px">Transfers</h5>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="table--paybee">
                        <table id="allTransfers" class="table table-hover" width="100%">
                            <thead class="thead-light">
                            <tr>
                                <th>Initiated</th>
                                <th style="white-space: nowrap;">Est. Arrival</th>
                                <th>Proceed</th>
                                <th>Donation</th>
                                <th style="white-space: nowrap;">Org Fee</th>
                                <th style="white-space: nowrap;">Transaction Fee</th>
                                <th style="white-space: nowrap;">PayBee Fee</th>
                                <th style="white-space: nowrap;">User Covered Fee</th>
                                <th>Refund</th>
                                <th style="white-space: nowrap;">Tax Collected</th>
                                <th>Adjustment</th>
                                <th>Destination</th>
                                <th>Status</th>
                            </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    
        <div id="campaignPieChartPage" class="content">
            <div id="allCampaignsPage">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a class="blue-text transferBreadCrumb" style="text-decoration: underline">Transfers</a></li>
                    <li class="breadcrumb-item active">All Campaigns</li>
                </ol>
                <h5 style="margin-top: 20px">Campaign Totals</h5>
                <div id="campaignBreakDown" class="row text-center" style="background:#f8f8f8; padding:10px 0px 10px 0px">
                    <div class="col"><canvas id="barChart"></canvas></div>
                </div>
    
                <h5 style="margin-top: 20px">Transfer By campaign</h5>
                <div class="row">
                    <div class="col">
                        <div class="table--paybee">
                            <table id="byCampaignTransfers" class="table table-hover" width="100%">
                                <thead class="thead-light">
                                <tr>
                                    <th>Date</th>
                                    <th>Campaign</th>
                                    <th>Proceed</th>
                                    <th>Donation</th>
                                    <th>Tax</th>
                                    <th style="white-space: nowrap;">Org Fee</th>
                                    <th style="white-space: nowrap;">Transaction Fee</th>
                                    <th style="white-space: nowrap;">PayBee Fee</th>
                                    <th style="white-space: nowrap;">User Covered Fee</th>
                                    <th>Status</th>
                                </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div id="transferDetailsPage" class="content">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a class="blue-text transferBreadCrumb" style="text-decoration: underline">Transfers</a></li>
                <li class="breadcrumb-item active">Transfer Details</li>
            </ol>
            <h4>Transfer Details</h4>
            <div class="row text-center" style="background:#f8f8f8; padding:10px 0px 10px 0px">
                <div class="col transferSummary">
                    <span>Transfer Date</span><br>
                    <span id="transferDate"></span>
                </div>
                <div class="col transferSummary">
                    <span>Proceed</span><br>
                    <span id="transferProceeds"></span>
                </div>
                <div class="col">
                    <span>Number of Donations</span><br>
                    <span id="transferNumDonation"></span>
                </div>
            </div>
            <div class="row text-center" style="background:#f8f8f8; padding:10px 0px 10px 0px">
                <div class="col transferSummary">
                    <span>Fee</span><br>
                    <span id="transferFee"></span>
                </div>
                <div class="col transferSummary">
                    <span>Refunds</span><br>
                    <span id="transferRefund"></span>
                </div>
                <div class="col transferSummary">
                    <span>Tax Collected</span><br>
                    <span id="transferTax"></span>
                </div>
                <div class="col">
                    <span>Adjustments</span><br>
                    <span id="transferAdjustments"></span>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="table--paybee">
                        <table id ="allDonations" class="striped table table-striped table-bordered table-rounded table-scrollable">
                            <thead>
                            <tr>
                                <th style="white-space: nowrap;">Donor Name</th>
                                <th>Campaign</th>
                                <th>Proceed</th>
                                <th>Donation</th>
                                <th>Date</th>
                                <th>Tax</th>
                                <th style="white-space: nowrap;">Org Fee</th>
                                <th style="white-space: nowrap;">Transaction Fee</th>                                
                                <th style="white-space: nowrap;">PayBee Fee</th>
                                <th style="white-space: nowrap;">User Covered Fee</th>
                                <th>Status</th>
                            </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>